import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Two-column toggle list — wraps ToggleSwitch items in the standard
 * form-horizontal / column layout used by features and dispositions.
 */
import { ToggleSwitch } from './ToggleSwitch';
export function ToggleList({ items, checked, onChange, sort = false }) {
    const visibleItems = items.filter((item) => item.display !== false);
    if (sort) {
        visibleItems.sort((a, b) => a.label.localeCompare(b.label));
    }
    return (_jsx("div", { className: "form-horizontal", children: _jsx("div", { className: "form-group col-xs-12", children: _jsx("div", { className: "col-xs-12", children: _jsx("div", { className: "row", children: _jsx("div", { style: { columnWidth: '400px', columnCount: 2 }, children: visibleItems.map((item) => (_jsx(ToggleSwitch, { label: item.label, checked: checked.includes(item.code), onChange: (isChecked) => onChange(item.code, isChecked) }, item.code))) }) }) }) }) }));
}
